import { useState, useEffect } from 'react';
import { NotificationToast } from '../../../../components/organisms/notification-toast';
import Modal, { ModalProps } from '../../../../components/template/mvc-modal';
import { useTranslation } from 'react-i18next';
import { EditableChangeEvent } from '../../../../utils/types/editable';
import Input from '../../../../components/atoms/input';
import MaintenanceService, {
	IMaintenanceType,
} from '../../../../services/Maintenance.service';

export interface MaintenanceTypeModalProps extends ModalProps<IMaintenanceType> {
	setModalProps: React.Dispatch<
		React.SetStateAction<ModalProps<IMaintenanceType>>
	>;
}

const MaintenanceTypeModal = ({
	data,
	setModalProps,
	onClose,
	mode,
	isModalVisible,
	...props
}: MaintenanceTypeModalProps) => {
	const { t } = useTranslation();

	const [error, setError] = useState<string>('');

	useEffect(() => {
		if (!error) return;
		NotificationToast.Warn(t(error));
		setError('');
	}, [error]);

	const onSubmit = () => {
		if (!validate()) return;
		onCreate();
	};

	const validate = (): boolean => {
		if (!data.description) {
			setError('alert.error.mandatory');
			return false;
		}
		return true;
	};

	const onCreate = async () => {
		const response = await MaintenanceService.createMaintenanceType(
			data,
			setError
		);
		if (!response) return;
		NotificationToast.Success(
			`${t('maintenance.type.title')} ${t('alert.success.create')}`
		);
		onClose(true);
	};

	const handleInput = (
		e: React.ChangeEvent<HTMLInputElement> | EditableChangeEvent
	) => {
		setModalProps((prev) => ({
			...prev,
			data: {
				...prev.data,
				[e.target.name]: e.target.value,
			},
		}));
	};

	const renderInputs = () => (
		<div className="grid gap-x-2 gap-y-3">
			<Input
				value={data.description}
				name="description"
				label={t('misc.description')}
				placeholder={t('misc.description')}
				onChange={handleInput}
				disabled={mode === 'view'}
				required
			/>
		</div>
	);

	return (
		<Modal<IMaintenanceType>
			onClose={onClose}
			data={data}
			mode={mode}
			onConfirm={onSubmit}
			isModalVisible={isModalVisible}
			{...props}
		>
			{renderInputs()}
		</Modal>
	);
};

export default MaintenanceTypeModal;
